import {
  initialCodesAllowed,
  subsequentCodesAllowed,
} from '../../../../../helper/chartValidationHelper'
import { VISIT_STATUS } from '../../../../../utils/statusConstants'
import { ENCOUNTER_TYPES } from '../../../sharedConstants'

export const VISIT_STATUSES = {
  Available: 'Available',
  Completed: 'Completed',
  Draft: 'Draft',
  Hold: 'Hold',
  NotSeen: 'Not seen',
}

export function calculateVisitStatus(isLastEncounter, status) {
  if (isLastEncounter) {
    return VISIT_STATUS.available
  }
  switch (status) {
    case VISIT_STATUS.not_seen:
      return VISIT_STATUSES.NotSeen
    case VISIT_STATUS.available:
    case 'Cancelled':
    case VISIT_STATUS.last:
    case VISIT_STATUS.scheduled:
      return VISIT_STATUSES.Available
    case 'Bill audit':
    case 'Bill hold':
    case VISIT_STATUS.bill_submitted:
    case 'Claim accepted':
    case VISIT_STATUS.claim_assigned:
    case 'Claim denied':
    case 'Claim hold':
    case 'Claim processed':
    case 'Claim received':
    case 'Claim rejected':
    case VISIT_STATUS.completed:
    case 'Patient assigned':
    case 'Patient hold':
    case 'Patient payment':
    case 'Patient statement sent':
    case 'Settled':
      return VISIT_STATUSES.Completed
    case VISIT_STATUS.admit:
    case VISIT_STATUS.bill_pending:
    case VISIT_STATUS.checked_in:
    case 'Collections assigned':
    case 'Collections review':
      return VISIT_STATUSES.Draft
    case VISIT_STATUS.bill_rejected:
    case 'Claim provider hold': // Status is unused ?
    case VISIT_STATUS.super_bill: // Status is unused ?
      return VISIT_STATUSES.Hold
    default:
      return VISIT_STATUSES.Available
  }
}

export function getCptEncTypeMismatch({ encounterType, emCode }) {
  const validationDirectives = JSON.parse(sessionStorage.getItem('directives/chart_validation'))

  if (!emCode?.em_code) {
    return ''
  }

  if (encounterType === ENCOUNTER_TYPES.INITIAL) {
    if (emCode && !initialCodesAllowed(validationDirectives).includes(emCode?.code)) {
      return '1st procedure code selected is not valid for initial encounter'
    }
  } else if (encounterType === ENCOUNTER_TYPES.SUBSEQUENT) {
    if (emCode && !subsequentCodesAllowed(validationDirectives).includes(emCode?.code)) {
      return '1st procedure code selected is not valid for subsequent encounter'
    }
  }

  return ''
}
